const QianKunUtils = {};

/**
 * 是否在qiankun中加载
 */
QianKunUtils.isInQianKun = function () {
  return window.__POWERED_BY_QIANKUN__;
};

/**
 * 接受主应用的传参
 * @param props 主应用穿的公共数据
 */
QianKunUtils.setCommonData = function (props) {
  const { data } = props;
  const { LoginUtils } = data;
  QianKunUtils.LoginUtils = LoginUtils;
};

export default QianKunUtils;
